var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96 23.954c6.982 7.022 16.223 9.154 20.642 4.761 4.419-4.392 2.342-13.646-4.64-20.669-6.98-7.022-16.222-9.154-20.64-4.761C-1.099 7.677.98 16.93 7.96 23.954zm4.41-4.615c4.481 4.574 9.807 6.623 11.897 4.576 2.09-2.046.151-7.414-4.33-11.988-4.48-4.575-9.806-6.624-11.895-4.578-2.09 2.047-.152 7.414 4.329 11.99z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPros);
export default __webpack_public_path__ + "static/media/PROS.aeca525929d4e6b0c4971dfcf7b99898.svg";
export { ForwardRef as ReactComponent };